import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { ResetTheme, SetNavTransparency } from 'src/app/store';

export const ResetTopbarGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (isPlatformBrowser(platformId) && router.currentNavigation() && router.currentNavigation()!.id <= 1) {
    return true;
  }

  store.dispatch(ResetTheme());
  store.dispatch(SetNavTransparency({ transparent: false }));
  return true;
};
